/* eslint max-classes-per-file: ["error", 3] */

import Enum from '@/modules/core/app/models/abstracts/Enum';

export const EntityType = 'order';

export const EntityOrderListName = 'Orders';

export const Limit = 2;

export class PortalStepConstants extends Enum {
  static PRODUCT_SELECTION = 0;

  static ORDER_INFORMATION = 1;

  static REVIEW_AND_CREATE = 2;
}

export class PortalProductCategories extends Enum {
  static BUNDLES = 'Bundles';

  static SEARCH_MARKETING = 'search_marketing';

  static DISPLAY = 'display';

  static PROGRAMMATIC = 'programmatic';

  static WEB_DESIGN = 'web_design';

  static SOCIAL = 'social';
}

export class PortalPriceUnit extends Enum {
  static FLAT_FEE = 'flat_fee';

  static STARTING_AT = 'starting_at';

  static MONTHLY = 'monthly';

  static PER_UNIT = 'per_unit';

  static FREEMIUM = 'freemium';
}

export const OrderDetailsTabConstants = {
  OVERVIEW: 'overview',
  LINEITEMS: 'line_item',
  TASKS: 'tasks',
  FILES: 'files',
};

export const EntityRoute = {
  ENTITY_ORDERS: 'entity/orders',
  CREATE_ORDER: 'create-order',
  EDIT_ORDER: 'edit-entity-orders',
};

export const CatalogueRoutes = {
  LIST_PAGE: 'cataloguepage',
  CART_PAGE: 'cataloguepage-cart',
  PRODUCT_DETAILS_PAGE: 'cataloguepage-product',
};

export const CartColors = [
  ['#75BB36', '#09D083'],
  ['#293462', '#A359FF'],
  ['#00953C', '#FFB621'],
  ['#ED495D', '#FDEDEF'],
  ['#FD3164', '#EF2FB9'],
  ['#216583', '#03CE99'],
  ['#00A0AE', '#45ADFF'],
  ['#F26321', '#0D84FB'],
  ['#B5328D', '#4469FF'],
  ['#F76262', '#02DAC5'],
  ['#BC7406', '#5E5CE6'],
  ['#006BBD', '#F3322C'],
  ['#CD2F2C', '#F69A8D'],
  ['#0F3298', '#CA87BA'],
];

export const OrderConstants = {
  ORDERDATA: 'orderData',
  FILES: 'Files',
  SUBMIT: 'submit',
  IS_DARK: 'is-dark',
  POSITION: 'is-top-right',
  CLICK: 'click',
  NOTIFICATION: '.notification',
  LINE_ITEM: 'line-item',
};

export const OrderEvent = {
  UPDATE_LINE_ITEMS_LIST: 'update-line-items-list',
  CHANGE_ORDER: 'change-order',
  CHANGE_STATUS: 'change-status',
  APPLY_FILTERS: 'apply-filters',
  CLEAR_FILTERS: 'clear-filters',
  UPDATE_ENTITY_STATUS: 'update-entity-status',
  UPDATE_ORDER_STATUS: 'update-order-status',
  VIEW_ORDER_LINE_ITEMS: 'view-order-line-items',
};

export const OrderFields = {
  ID: 'id',
  NAME: 'name',
  DISPLAY_NAME: 'display_name',
  SELECT_PLACEHOLDER: 'Select',
  CLIENT: 'Client',
  CLIENT_ID: 'client_id',
  ORDER: 'Order',
  PRODUCT: 'Product',
  PRODUCT_ID: 'product_id',
  STATUS_TITLE: 'Order Status',
  STATUS_FIELD: 'status',
  START_DATE_TITLE: 'Start Date',
  START_DATE_FIELD: 'start_date',
  END_DATE_TITLE: 'End Date',
  END_DATE_FIELD: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  TOTAL_BUDGET_TITLE: 'Total Budget',
  CREATED_BY: 'Created By',
  CREATED_BY_USER_ID: 'created_by_user_id',
  CREATED_ON: 'Created On',
  CREATED_AT: 'created_at',
  CLIENT_FIELD: 'client',
  BUSINESS_UNITS: 'Business Units',
  CLUSTER_ID: 'cluster_id',
};

export const OrderStatuses = {
  STATUS_DRAFT: 'Draft',
};

export const ValidationErrorMessage = {
  MESSAGE: 'Please fill in all required information before submitting the order',
  TYPE: 'is-danger is-light',
};

export const QueryQuickview = 'quickview';

export const CLASSIC_OPEN_ORDERS_ROUTE = '/client/iotool/dist/#/items/orders';

export const CLASSIC_VIEW_ORDER_URL = '/client/iotool/dist/#/items/viewOrder';

export const OrderCreationJourneySteps = {
  LINE_ITEMS: 'line-items',
  ORDER: 'order',
};

export const OrdersRoutePathName = 'orders';
